import React, { FC } from 'react';
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router';
import { GxSpinner } from '@garpix/garpix-web-components-react';
import cn from 'classnames';
import 'react-responsive-modal/styles.css';
import dayjs from 'dayjs';
import { api } from '@/api';
import StatisticSortMenu from './PayOrderSortmenu';
import Pagination from '../../../../../../components/Pagination';
import DateFormat from '../../../../../../components/DateFormat';
import { FETCHER_STATUS } from '../../../../../../const';
import { TPayOrder } from '../../../../../../types';
import { NAME_STATUS_SCORE, PAY_ORDER_TYPES_STATUS, } from '../../../../consts';
import styles from '../../styles/index.module.scss';

interface IPayOrderPanelTableProps {
  userId: number;
}

const PayOrderPanelTable: FC<IPayOrderPanelTableProps> = ({ userId }) => {
  const tableTh = [
    { id: 1, title: '№ заявки' },
    { id: 2, title: 'Дата создания' },
    { id: 3, title: 'Услуга' },
    { id: 6, title: 'Сумма' },
    { id: 8, title: 'Статус' },
  ];

  return (
    <div className={styles['orders']}>
      <h2 className={styles['orders--title']}>Счета</h2>
      {userId ? (
        <FetcherList
          api={api.order.getPayOrder}
          isHistoryPush={false}
          initFilter={{ customer: userId, limit: 10, side: 1, start_date: dayjs().format('YYYY-MM-DD'), service_type: 0 }}
        >
          {({
            results = [],
            count,
            filterParams,
            activePage,
            loadData,
            status,
          }: any) => {
            const isLoading = status === FETCHER_STATUS.loading;
            const isLoaded = status === FETCHER_STATUS.loaded;
            const isNotFounded =
              isLoaded && results.length === 0 && filterParams.end_date;
            return (
              <>
                <StatisticSortMenu
                  filterParams={filterParams}
                  loadData={loadData}
                />
                <div className={styles['table']}>
                  <table>
                    <thead>
                      <tr>
                        <th>Счёт</th>
                        <th>Дата создания</th>
                        <th>Услуга</th>
                        <th>Стоимость</th>
                        <th>Статус</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isNotFounded && (
                        <tr>
                          <td className={styles['table--empty']} colSpan={8}>
                            Ничего не найдено.
                          </td>
                        </tr>
                      )}
                      {isLoading && (
                        <tr>
                          <td className={styles['table--loading']} colSpan={8}>
                            <GxSpinner />
                          </td>
                        </tr>
                      )}
                      {isLoaded &&
                        results.map((order: TPayOrder) => {
                          const {
                            id,
                            created_at,
                            service_name,
                            status,
                            amount
                          } = order;
                          return (
                            <tr key={id}>
                              <td
                              >
                                № {id}
                              </td>
                              <td>
                                <DateFormat date={created_at} />
                              </td>
                              <td>{service_name}</td>
                              <td>
                                {Math.trunc(Number(amount)).toLocaleString()} &#8381;
                              </td>
                              <td>
                                <span
                                  className={cn(
                                    styles['table--status'],
                                    styles[
                                    `table--status-orders_${NAME_STATUS_SCORE[PAY_ORDER_TYPES_STATUS[status || 0]]
                                      .class
                                    }`
                                    ]
                                  )}
                                >
                                  {NAME_STATUS_SCORE[PAY_ORDER_TYPES_STATUS[status]].title}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className={styles['application-amount']}>
                  <div className={styles['application-amount--pagination']}>
                    {!!count && (
                      <Pagination
                        total={count}
                        pageSize={10}
                        onChange={(page: number) =>
                          loadData(page, filterParams)
                        }
                        activePage={activePage}
                      />
                    )}
                  </div>
                </div>
              </>
            );
          }}
        </FetcherList>
      ) : (
        <>
          <StatisticSortMenu isDisabled />
          <div className={styles['table']}>
            <table>
              <thead>
                <tr>
                  {tableTh.map(({ id, title }) => {
                    return <th key={id}>{title}</th>;
                  })}
                </tr>
              </thead>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default PayOrderPanelTable;
